import ProductPriceScheduleDetails from './schemas/ProductPriceScheduleDetails.json';
import ProductPriceScheduleSellPrices from './schemas/ProductPriceScheduleSellPrices.json';

export default {
    ProductPriceScheduleDetails,
    ProductPriceScheduleSellPrices,
};
